import { API, handleApiError } from "./utils";

export const getCameras = async (search, sites, sortOrder, sortedColumn, status, page, per_page, zones, order_by) => {
  try {
    const { data } = await API.get("/get_cameras", {
      params: {
        search,
        sites,
        sortOrder,
        sortedColumn,
        status,
        page,
        per_page,
        zones,
        order_by
      },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const getCameraByID = async (id) => {
  try {
    const { data } = await API.get(`/cameras/${id}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const getCamerasNoRule = async () => {
  try {
    const { data } = await API.get("/cameras/no_rule");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const cameraAdd = async (camera) => {
  try {
    const { data } = await API.post("/cameras/", {
      name: camera.Name,
      username: camera.Username,
      password: camera.Password,
      ip_address: camera.IP_Address,
      port_number: camera.Port_Number,
      manufacturer: camera.Manufacturer,
      model: camera.Model,
      url: camera.url,
      url_cloud: camera.url,
      zone_id: camera.Zone,
      status: 0,
      // fps: camera.fps,
      rotation: camera.Rotation ? 1 : 0,
      rotation_degree: camera.Rotation ? (Number(camera.Rotation_degree) || 0) : 0,
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const cameraUpdate = async (camera) => {
  try {
    console.log("apiEdit", camera)
    const { data } = await API.put(`/cameras/${camera.Camera_ID}`, null, {
      params: {
        name: camera.Name,
        username: camera.Username,
        password: camera.Password,
        ip_address: camera.IP_Address,
        port_number: camera.Port_Number,
        manufacturer: camera.Manufacturer,
        model: camera.Model,
        url: camera.url,
        url_cloud: camera.url,
        zone_id: camera.Zone,
        status: camera.Status,
        // fps: camera.fps,
        rotation: camera.Rotation ? 1 : 0,
        rotation_degree: camera.Rotation ? (Number(camera.Rotation_degree) || 0) : 0,
      }
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

// Rotation-only update -- unlike cameraUpdate, this never sends
// credentials/URL, so it's safe to call from screens (rule editor, camera
// feed) that only ever hold the camera's public fields and would otherwise
// blank Username/Password/URL by omitting them from a full cameraUpdate call.
export const cameraUpdateRotation = async (cameraId, rotation, rotationDegree) => {
  try {
    const { data } = await API.put(`/cameras/${cameraId}/rotation`, null, {
      params: {
        rotation: rotation ? 1 : 0,
        rotation_degree: rotation ? (Number(rotationDegree) || 0) : 0,
      }
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const cameraON = async (camera) => {
  try {
    console.log("apiEdit", camera)
    const { data } = await API.put(`/cameras/ON/${camera.Camera_ID}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const cameraOFF = async (camera) => {
  try {
    console.log("apiEdit", camera)
    const { data } = await API.put(`/cameras/OFF/${camera.Camera_ID}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

// ids omitted => every camera in the caller's company (optionally narrowed to `site`).
export const camerasBulkStatus = async (status, { ids, site } = {}) => {
  try {
    const body = { status };
    if (ids) body.ids = ids;
    if (site) body.site = site;
    const { data } = await API.put(`/cameras/bulk/status`, body);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const cameraDelete = async (camera, options = {}) => {
  try {
    const { data } = await API.delete(`/cameras/${camera}`, {
      skipSuccessToast: options.skipSuccessToast || false,
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const getCameraStream = async (cameraId) => {
  try {
    const { data } = await API.get(`/cameras/${cameraId}/stream`, {
      responseType: 'blob',
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getProducts = async (manufacturer, model) => {
  try {
    const { data } = await API.get(`/products/`, {
      params: {
        manufacturer,
        // model
      },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getOneFrame = async (id) => {
  try {
    const { error, data } = await API.get(`/preview_frame/${id}`, {
      responseType: 'blob',
      params: { t: Date.now() },
      headers: { "Cache-Control": "no-cache" },
    });
    return { error, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getCameraHealth = async (id = null) => {
  try {
    const path = id == null ? "/cameras/health" : `/cameras/health/${id}`;
    const { data } = await API.get(path, {
      params: { t: Date.now() },
      headers: { "Cache-Control": "no-cache" },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getCameraPreview = async (cameraId) => {
  try {
    await API.get(`/preview_frame/${cameraId}`, {
      responseType: 'blob',
      params: { t: Date.now() },
      headers: { "Cache-Control": "no-cache" },
    });
  } catch (e) {
    // ignore, just keeping health alive
  }
};
